import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

import { numeroAColumnaExcel } from '../../../../utils/excelJsUtil';
import HeadersExcelJsDecorator from '../../../../decorators/headersExcelJsDecorator';
import TableExcelJsDecorator from '../../../../decorators/tableExcelJsDecorator';
import {
  TITLE_LEFT,
  TITLE_CENTER,
  COLUMN_MONEY_20,
} from '../../../../data/excelJsData';

const TITLE_LEFT_40 = { width: 40, ...TITLE_LEFT };
const TITLE_LEFT_25 = { width: 25, ...TITLE_LEFT };
const TITLE_LEFT_20 = { width: 20, ...TITLE_LEFT };
const TITLE_CENTER_14 = { width: 14, ...TITLE_CENTER };
const TITLE_CENTER_20 = { width: 20, ...TITLE_CENTER };
const COLUMN_MONEY_22 = { width: 22, ...COLUMN_MONEY_20 };

const COLUMNS = [
  { name: 'Identificación', key: 'identificacion', ...TITLE_CENTER_20 },
  { name: 'Nombres', key: 'nombreCompleto', ...TITLE_LEFT_40 },
  { name: 'Cargo', key: 'Cargo', ...TITLE_LEFT_25 },
  { name: 'Tipo de contrato', key: 'tipoContrato', ...TITLE_LEFT_20 },
  { name: 'Empresa', key: 'DescCompañia', ...TITLE_LEFT_40 },
  { name: 'Sucursal', key: 'DescripcionSucursal', ...TITLE_LEFT_40 },
  { name: 'Fecha ingreso', key: 'fechaIngresoFormateada', ...TITLE_CENTER_14 },
  {
    name: 'Fecha contrato hasta',
    key: 'fechaContratoHastaFormateada',
    ...TITLE_CENTER_20,
  },
  { name: 'Salario', key: 'Salario', ...COLUMN_MONEY_22 },
];

export const descargarHistoricoEmpleadosRetirados = async datos => {
  const { fileName, empleadosRetirados } = datos;
  const ultimaColumnaLetra = numeroAColumnaExcel(COLUMNS.length);
  const rangoHeader = `A1:${ultimaColumnaLetra}1`;

  const HEADERS = {
    title: 'Empleados retirados',
    rangoHeader,
  };

  const workbook = new ExcelJS.Workbook();
  const ws = workbook.addWorksheet('Empleados Retirados');
  const START_ROW = 3;
  new HeadersExcelJsDecorator(ws).encabezadoSimpleRangoDimanico(HEADERS);
  new TableExcelJsDecorator(ws).addTable(
    START_ROW,
    COLUMNS,
    empleadosRetirados
  );

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  saveAs(blob, fileName);
};
